import service from '@/utils/request.js'
import axios from 'axios'
import { localData } from "@/utils/local.js"

/**
 * 获取api服务token
 * 场景：获取省市区
 */
// const url_api = "http://apitest.juhepai.cn" // 测试环境
const url_api = "https://carapi.smart360.cn" // 线上环境
function getSmartToken() {
	return new Promise((resolve, reject) => {
		service.getRequest(`/common/smart/token`).then(res => {
			if (res.errCode == 0) {
				let zpThirdToken = res.data.token;
				resolve(zpThirdToken);
			}
		})
	})
}
/**
 * 省市区列表
 * 场景：公共
 * scope：0-省市区、1-全部省、2-全部市、3-全部区、4-省市
 * sortType：0-行政区code、1-按首字母、2-按首字母分组排序
 */
function getCitysList(params, zpThirdToken) {
    return new Promise((resolve, reject) => {
		axios.get(`${ url_api }/bs/district/list`,{
			headers: {
				token: zpThirdToken
			},
			params: params
		}).then(res => {
			if(res.status == 200){
				localData("set", "JT_CITYS", res.data.data);
				resolve(res.data.data);
			}
		})
    });
}

/**
 * 获取品牌数据
 */
function getBrandList(zpThirdToken) {
	return new Promise((resolve, reject) => {
		axios.get(`${ url_api }/bs/brand/list`,{
			headers: {
				token: zpThirdToken
			},
		}).then(res => {
			if(res.status == 200){
				localData("set", "JT_BRAND", res.data.data);
				resolve(res.data.data);
			}
		})
	});
}
/**
 * 获取车系数据，选择品牌回调用
 */
function getSeriesList(brandId, zpThirdToken) {
	if (brandId == undefined) {
		return
	}
	return new Promise((resolve, reject) => {
		axios.get(`${ url_api }/bs/mfrs/series/brandId/${brandId}`,{
			headers: {
				token: zpThirdToken
			},
			params: { brandId: brandId },
		}).then(res => {
			if(res.status == 200){
				let arr = []
				res.data.data.forEach((ele, index) => {
					if(ele.seriesList){
						arr = arr.concat(ele.seriesList)
					}
				})
				resolve(arr)
			}
		})
	});
}
/**
 * 获取车型数据，选择车系回调用
 */
function getModelList(seriesId, zpThirdToken) {
	if (seriesId == undefined) {
		return
	}
	return new Promise((resolve, reject) => {
		axios.get(`${ url_api }/bs/model/seriesId/${seriesId}`,{
			headers: {
				token: zpThirdToken
			},
			params: { seriesId: seriesId },
		}).then(res => {
			if(res.status == 200){
				if (res.data.data.length > 0) {
					let arr = []
					res.data.data.forEach((item, index) => {
						if (item.list.length > 0) {
							item.list.forEach((val, idx) => {
								let obj = {
									name: item.year + '款' + val.name,
									id: val.id,
									year: item.year,
									modelCode: val.modelCode,
                  					model: val.name,
								}
								arr.push(obj)
							})
						}
					})
					resolve(arr)
				}
			}
		})
	})
}

/**
 * 查询经销商下拉列表
 */
function getDealerList() {
	return new Promise((resolve, reject) => {
		service.getRequest('/company/findAll').then(res => {
			if (res.errCode == 0) {
				resolve(res.data)
			}
		})
	})
}

/**
 * 公共数据词典
 */
function getDictionary(type) {
	let data = []
	switch (type) {
		case 'refundStatus':
			// 退款状态
			data = [
				{ name: '未退款', value: 0 },
				{ name: '已退款(全部退款)', value: 1 },
				{ name: '已退款(部分退款)', value: 2 },
			]
		break
		case 'refundType':
			// 退款状态
			data = [
				{ name: '支付订单原路返回', value: 1 },
				{ name: '支付订单原路返回(部分退款)', value: 2 },
				{ name: '手动转账退款(部分退款)', value: 3 },
			]
		break
		case 'examineStatus':
			// 车辆审核状态
			data = [
				{ name: '审核中', value: 1 },
				{ name: '审核通过', value: 2 },
				{ name: '审核驳回', value: 3 },
				{ name: '拍卖中', value: 4 },
				{ name: '中拍', value: 5 },
				{ name: '取消中拍', value: 6 },
				{ name: '流拍', value: 7 },
				{ name: '取消上拍', value: 8 },
				{ name: '确认中拍', value: 9 },
			]
		break
		case 'invoiceStatus':
			// 开票状态
			data = [
				{ name: '未开票', value: 0 },
				{ name: '已开票', value: 1 },
			]
		break
		case 'carColor'://车身颜色
			data = [
				{ "code": "0", "text": "其他" },
				{ "code": "1", "text": "黑色" },
				{ "code": "10", "text": "黄色" },
				{ "code": "11", "text": "橙色" },
				{ "code": "12", "text": "粉色" },
				{ "code": "13", "text": "棕色" },
				{ "code": "14", "text": "双色" },
				{ "code": "15", "text": "银灰色" },
				{ "code": "16", "text": "粉红色" },
				{ "code": "17", "text": "深灰色" },
				{ "code": "18", "text": "咖啡色" },
				{ "code": "19", "text": "香槟色" },
				{ "code": "2", "text": "蓝色" },
				{ "code": "3", "text": "白色" },
				{ "code": "4", "text": "红色" },
				{ "code": "5", "text": "银色" },
				{ "code": "6", "text": "金色" },
				{ "code": "7", "text": "绿色" },
				{ "code": "9", "text": "紫色" }
			]
		break;
		case 'purpose'://车辆使用性质
			data = [
				{ text: '非营运', code: '10' },
				{ text: '营运', code: '20' },
				{ text: '营转非', code: '30' },
				{ text: '租赁', code: '40' },
				{ text: '公务车', code: '80' },
			]
		break;
		case 'carCondition'://车辆状况
			data = [
				{ "code": "1", "text": "极好" },
				{ "code": "2", "text": "好" },
				{ "code": "3", "text": "一般" },
				{ "code": "4", "text": "差" },
				{ "code": "5", "text": "极差" }
			]
		break;
		case 'tradeTime':
			data = [
				{ code: 0, text: "0次" },
				{ code: 1, text: "1次" },
				{ code: 2, text: "2次" },
				{ code: 3, text: "3次" },
				{ code: 4, text: "4次" },
				{ code: 5, text: "5次" },
				{ code: 6, text: "6次" },
				{ code: 7, text: "7次" },
				{ code: 8, text: "8次" },
				{ code: 9, text: "9次" },
				{ code: 10, text: "10次及10次以上" },
			]
		break;
		case 'energyType'://能源类型
			data = [
				{ "code": "1", "text": "燃油" },
				{ "code": "2", "text": "纯电" },
				{ "code": "3", "text": "混动" }
			]
		break;
		case 'emissionStandard'://排放标准
			data = [
				{ "code": "10", "text": "国二及以下" },
				{ "code": "30", "text": "国三" },
				{ "code": "40", "text": "国四" },
				{ "code": "50", "text": "国五" },
				{ "code": "120", "text": "国六" },
				{ "code": "130", "text": "新能源" }
			]
		break;
		case 'affiliation'://车辆性质
			data = [{ text: '个人', code: '0' },{ text: '单位', code: '1' } ]
		break;
		case 'gearbox'://变速箱形式
			data = [
				{ "code": "0", "text": "手动" },
				{ "code": "1", "text": "自动" }
			]
		break;
		case 'drivingType'://驱动类型
			data = [
				{ text: '两驱', code: '两驱' },{ text: '四驱', code: '四驱' } 
			]
		break;
		case 'refit'://是否改装
			data = [{ text: '是', code: '1' },{ text: '否', code: '0' } ]
		break;
		case 'carTicket'://车船税
			data = [{ text: '有', code: '1' },{ text: '无', code: '0' } ]
		break;
		case 'nameplateStatus'://铭牌状况
			data = [
				{ "code": "0", "text": "完好" },
				{ "code": "1", "text": "铭牌破损" }
			]
		break;
		case 'entranceType'://国产/进口
			data = [{ text: '进口', code: '1' },{ text: '国产', code: '0' } ]
		break;
	}
	return data
}

/* 
 * 回显picker 词典数据
 * 场景：快估回显、评估报告回显、评估报告详情回显
 */
function getDictionaryDetail(value, type, keyValue){
	let pickers = getDictionary(type)
	let pickerName = ''
	let pickerValue = ''
	let pickerIndex = -1
	pickers.forEach((item, index) => {
		if(item[keyValue] == value){
			pickerName = item.name
			pickerValue = item[keyValue]
			pickerIndex = index
		}
	})
	return { pickerName, pickerValue, pickerIndex }
}
function getDictionaryDetailText(value, type, keyValue){
	let pickers = getDictionary(type)
	let pickerName = ''
	let pickerValue = ''
	let pickerIndex = -1
	pickers.forEach((item, index) => {
		if(item[keyValue] == value){
			pickerName = item.text
			pickerValue = item[keyValue]
			pickerIndex = index
		}
	})
	return { pickerName, pickerValue, pickerIndex }
}

function getImgList(type, isRequired) {
	let data = []
	switch (type) {
		case 'carImgList':
			//车辆照片
			data = [
				{ imgUrl: '', tempUrl: '', name: '行驶证', key: 'drivingLicenseImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '左前45度', key: 'leftfrontImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '车身左侧', key: 'leftImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '左前门内侧', key: 'leftInsideImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '驾驶位左侧（含左B柱）', key: 'driverLeftImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '中控与方向盘', key: 'szmAndSteerImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '仪表盘(发动中)', key: 'dashboardImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '车钥匙', key: 'carKeyImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '后排座左侧', key: 'rearSeatImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '中控全景（后座往前拍）', key: 'szmImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '后备箱整体', key: 'trunkImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '后备箱底板', key: 'trunkBottomImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '右后45度', key: 'rightbackImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '副驾驶右侧', key: 'coDriverRightImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '发动机机舱左侧', key: 'engineLeftImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '发动机机舱右侧', key: 'engineRightImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '发动机整体', key: 'engineCompartmentImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '出厂铭牌', key: 'nameplateImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '轮毂', key: 'hubImg', required: true },
				{ imgUrl: '', tempUrl: '', name: '其他', key: 'otherImg', required: false },
			]
		break

	}
	return data
}

export default {
    getSmartToken,
	getCitysList,
	getBrandList,
	getSeriesList,
	getModelList,
	getDictionary,
	getDictionaryDetail,
	getDictionaryDetailText,
	getDealerList,
	getImgList
}


// WEBPACK FOOTER //
// ./src/utils/jtUtils.js